export default function setInstagram() {
  const instagramSwiper = new Swiper('[data-instagram-swiper]', {
    slidesPerView: 3,
    spaceBetween: 4,
    preloadImages: false,
    speed: 1000,
    lazy: {
      checkInView: true,
      loadPrevNext: false,
      loadOnTransitionStart: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 4,
        spaceBetween: 8,
      },
      992: {
        slidesPerView: 6,
        spaceBetween: 8,
      },
    },
    pagination: {
      el: '[data-instagram-swiper] .swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
  });
}
